export const ourblog = [
    {
        title: "Marketing",
        date: "09 Dec 2022",
        discription: "Demystifying AI: A Beginner's Guide to Artificial Intelligence. The Impact of AI on Everyday Life: What You Need to Know.",
    },
    {
        title: "Digital",
        date: "11 Feb 2022",
        discription: "AI in Healthcare: Revolutionizing Medicine and Patient Care. Ethical Considerations in AI: Navigating the Moral Landscape.",
    },
    {
        title: "eCommerce",
        date: "22 Nov 2022",
        discription: "AI and Business: How Companies Are Leveraging Artificial Intelligence. How AI Is Changing the Job Landscape.",
    },
]